var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"user-view"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('student-tab-overview',{attrs:{"groupsData":_vm.groupsData,"userData":_vm.userDataStorage}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }